import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { CognitoService } from '../../common/api/services/cognito.service'

@Component({
    selector: 'app-auth-redirect',
    template: '<div class="auth-redirect-loader"><p>Authenticating...</p></div>',
    styles: ['.auth-redirect-loader { display: flex; justify-content: center; align-items: center; height: 100vh; }']
})
export class AuthRedirectComponent implements OnInit {
  constructor (
    private cognitoService: CognitoService,
    private router: Router
  ) {}

  async ngOnInit (): Promise<void> {
    // MSAL handleRedirectPromise is called during initialize().
    // Once tokens are stored, navigate back to where the user was.
    try {
      await this.cognitoService.initialize()
      await this.cognitoService.getAccessToken()
      // Navigate to the previous page or landing page
      const previousUrl = sessionStorage.getItem('preAuthUrl') || '/'
      sessionStorage.removeItem('preAuthUrl')
      this.router.navigateByUrl(previousUrl)
    } catch (error) {
      console.error('Auth redirect failed:', error)
      await this.cognitoService.loginRedirect()
    }
  }
}
